<div class="email-container px-3">
  <div class="row">
    <div class="col-md-3 col-lg-3 col-xl-2 bg-white border-right"><!-- style="padding-top: 40px;">-->
      <div class="table-responsive" style="margin-top: 20px;" >
        <table class="table bg-white table-hover align-middle mb-0 no-wrap">
          <thead>
          <tr>
            <th style="height: 60px;" class="align-middle"> Settings </th>
          </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of Settings">
              <td (click)="clicked(item)" class="align-middle" [ngStyle]="{ 'background-color': BG_Color(item.id == sel_cat_id)}">
                <span class="text-dark font-medium font-16">
                  <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
                    <i-feather name="info" class="feather-sm"></i-feather>
                  </span>
                  {{ item.label}}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="p-3 col-md-9 col-lg-9 col-xl-10 bg-white">
      <div class="inbox-right-panel">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
